import React from "react";
import { formatPlanParams, planStatusDisplay } from "../lib/planStatus";

export default function PlanCatalogTable({ plans, loading, onToggleStatus }) {
  if (!plans.length && !loading) {
    return <p>No hay planes en el catálogo. Creá el primero con «Nuevo plan».</p>;
  }

  return (
    <table className="ops-table">
      <thead>
        <tr>
          <th>Plan</th>
          <th>Parámetros</th>
          <th>Fee/mes</th>
          <th>Vigencia</th>
          <th>Estado</th>
          <th>Acciones</th>
        </tr>
      </thead>
      <tbody>
        {plans.map((plan) => {
          const status = planStatusDisplay(plan);
          return (
            <tr key={plan.plan_id}>
              <td>
                <strong>{plan.name}</strong>
                <br />
                <small>{plan.plan_id}</small>
              </td>
              <td>{formatPlanParams(plan)}</td>
              <td>
                {plan.monthly_base_fee_ars
                  ? `$${Number(plan.monthly_base_fee_ars).toLocaleString("es-AR")}`
                  : "—"}
              </td>
              <td>
                {plan.valid_from || "—"} → {plan.valid_until || "—"}
              </td>
              <td>
                <span className={`ops-plan-status ${status.className}`}>{status.label}</span>
              </td>
              <td>
                <button
                  type="button"
                  className="ops-btn secondary"
                  disabled={loading}
                  onClick={() =>
                    onToggleStatus(plan.plan_id, plan.status === "active" ? "inactive" : "active")
                  }
                >
                  {plan.status === "active" ? "Desactivar" : "Activar"}
                </button>
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
}
